import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheFileViewer = _resolveComponent("TheFileViewer")!
  const _component_ModalSheet = _resolveComponent("ModalSheet")!

  return (_openBlock(), _createBlock(_component_ModalSheet, {
    class: "file-viewer-mobile",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_TheFileViewer, { item: _ctx.item }, null, 8, ["item"])
    ]),
    _: 1
  }))
}